// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox__checkbox___dGd5x"};